import React from 'react';
import { Container } from 'react-bootstrap';
import { Redirect } from "react-router-dom";

/**
 * Gets user's credentials and redirects to the Dashboard
 */
class Login extends React.PureComponent {
    state = { isLogged: false }
    Login(e) {
        e.preventDefault();
        if(this.state.username === "rtELES@d7" && this.state.password === ".io/rel-O871"){
            this.props.onLoggedIn({ username: this.state.username, password: this.state.password, admin: true });
            this.setState({ isLogged: true });
        }
    }
    change(e, field) {
        this.setState({ [field]: e.target.value })
    }

    render() {
        if (this.state.isLogged) {
            return <Redirect to='/dashboard' />
        }
        return (
            <Container>
                <form onSubmit={e => this.Login(e)}>
                    <div className="form-group">
                        <label htmlFor="exampleInputEmail1">Username</label>
                        <input type="text" className="form-control" id="inputEmail1" aria-describedby="emailHelp" onChange={e => this.change(e, "username")} />
                    </div>
                    <div className="form-group">
                        <label htmlFor="exampleInputPassword1">Password</label>
                        <input type="password" className="form-control" id="inputPassword1" onChange={e => this.change(e, "password")} />
                    </div>
                    <button type="submit" className="btn btn-primary">Submit</button>
                </form>
            </Container>
        )
    }
}

export default Login;